import { BANNER_DUCK } from '../../core/actions'

export const BannerInitialState = {
  openBannerKeys: [],
}

export const BannerReducer = (state, { type, payload }) => {
  switch (type) {
    case BANNER_DUCK.SHOW_BANNER:
      return { ...state, openBannerKeys: [...state.openBannerKeys, payload] }
    case BANNER_DUCK.HIDE_BANNER:
      return { ...state, openBannerKeys: state.openBannerKeys.filter(key => key !== payload) }
    default:
      return state
  }
}
